<template>
    <div class="pageBox">
        <Header current='souye' ref="Header"></Header>
        <div class="pageBox_cen">
            <!-- <template v-for="(item, index) in list">
				<component :is="mapComponent[item.name]" :list='item' :ref="item.name" />
			</template> -->
            <contactBanner ref="contactBanner"></contactBanner>
            <div class="missionBox">
                <div class="missionBoxWidth">
                    <div :style="{ backgroundImage: `url('${item.cover}')` }" v-for="item in content" :key="item.id"
                        class="missionItem">
                        <div class="title">{{ item.title }}</div>
                        <div class="contentText">
                            {{ item.desc }}
                        </div>
                    </div>
                </div>
            </div>

            <companyMap :title="mapTitle" :locations="locations"></companyMap>

            <div class="numberBox">
                <div v-for="item in distributors" :key="item.id" class="numberItem">
                    <div class="topNum">{{ item.num }}+</div>
                    <div class="numText">{{ item.title }}</div>
                </div>
            </div>

            <Partners paddingTop="200px" :showMore="false" :dataInfo="awards"></Partners>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from "@/components/header.vue"
import Footer from "@/components/footer.vue"
import indexTitle from "@/components/c/indexTitle.vue"
import mapComponent from "@/components/mapComponent.js"
import contactBanner from "@/components/c/contactBanner.vue"
import Partners from "@/components/c/Partners.vue"
import companyMap from "@/components/c/companyMap.vue"
import {
    get_banner,
} from "@/api/index.js"
import { get_company_data } from '@/api/about'

export default {
    components: {
        Header,
        Footer,
        indexTitle,
        contactBanner,
        Partners,
        companyMap,
    },
    data() {
        return {
            mapComponent,
            awards: {
                moduleTitle: '',
                is_show: 1,
                list: [],
            },
            content: [],
            distributors: [],
            mapTitle: '',
            locations: [],
        }
    },
    created() {
        this.getDataInfo()
    },
    mounted() {
        let t = this;
        window.addEventListener('scroll', this.handleScroll);
        this.currentRoute = this.$route.path; // 初始化时获取当前路由地址
        this.$watch('$route', this.onRouteChange);
        var element;
        if (this.nowVibe == 'pc') {
            element = document.documentElement
        } else {
            element = document.documentElement.scrollTop ? document.documentElement : document.body;
        }
        let scrollTop = element.scrollTop;
        if (scrollTop == 0) {
            this.$refs.Header.headerHover = false;
            this.$refs.Header.headerTrue = false;
        } else {
            this.$refs.Header.headerTrue = true;
            this.$refs.Header.headerHover = true;
        }
        this.getBannerList(6)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);

    },
    methods: {
        handleScroll() {
            const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body
                .scrollTop || 0;
            if (currentScrollTop > this.lastScrollTop) {
                this.navHidden = true;
            } else {
                this.navHidden = false;
            }
            this.lastScrollTop = currentScrollTop;

            if (currentScrollTop == 0) {
                if (!this.$refs.Header.navHead) {
                    this.$refs.Header.headerHover = false;
                }
                this.$refs.Header.headerTrue = false;
            } else {
                this.$refs.Header.headerTrue = true;
                this.$refs.Header.headerHover = true;
            }
        },
        // 获取轮播图
        getBannerList(e) {
            let t = this;
            let data = {
                type: e
            }
            get_banner(data).then((res) => {
                console.log(res)
                this.$nextTick(function () {
                    t.$refs['contactBanner'].setList(res.data);
                })
            }).catch((err) => {
                console.log(err)
            })
        },
        getDataInfo() {
            get_company_data().then(res => {
                this.content = res.data.content
                res.data.awards.moduleTitle = res.data.awards.title
                res.data.awards.is_show = 1
                this.awards = res.data.awards
                this.distributors = res.data.distributors
                this.locations = res.data.maps.list.map(el => {
                    return {
                        name: el.title,
                        icon: el.cover,
                        lat: el.latlng.split(',')[1],
                        lon: el.latlng.split(',')[0],
                    }
                })
                this.mapTitle = res.data.maps.title
            })
        },
    }
}
</script>

<style></style>
<style scoped lang="scss">
.pageBox {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    overflow-x: hidden;

    .pageBox_cen {
        flex: 1;
        min-width: 0;
        max-width: 100%;
    }
}

.missionBox {
    background: #FFFFFF;
    margin-bottom: 200px;
    margin-top: 200px;

    .missionBoxWidth {
        width: 1200px;
        margin: auto;

        .missionItem {
            min-height: 180px;
            margin-top: 18px;
            position: relative;
            background-repeat: no-repeat;
            background-size: auto 100%;
            background-position: left center;

            .title {
                font-weight: 500;
                font-size: 32px;
                line-height: 32px;
                color: #000000;
                font-weight: bold;
            }

            .contentText {
                font-size: 24px;
                color: #000000;
                line-height: 32px;
                margin-top: 34px;
            }
        }
    }
}

.numberBox {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding-top: 200px;

    .numberItem {
        padding: 0 100px;

        .topNum {
            font-size: 48px;
            color: #010000;
            line-height: 48px;
            font-weight: bold;
            padding-bottom: 25px;
            margin-bottom: 20px;
            position: relative;
            text-align: center;

            &::after {
                content: '';
                width: 45px;
                height: 2px;
                background: #000000;
                position: absolute;
                left: 50%;
                transform: translate(-50%, 0);
                bottom: 0;
            }
        }

        .numText {
            font-size: 24px;
            color: #010000;
            line-height: 24px;
            text-align: center;
        }
    }
}

@media screen and (max-width:1200px) {
    .missionBox {
        background: #FFFFFF;
        margin-bottom: 50px;
        margin-top: 50px;

        .missionBoxWidth {
            width: 100%;
            margin: auto;
            padding: 0 30px;

            .missionItem {
                margin-top: 18px;
                position: relative;
                background-repeat: no-repeat;
                background-size: auto 100%;
                background-position: left center;

                .title {
                    font-weight: 500;
                    font-size: 32px;
                    color: #000000;
                    font-weight: bold;
                }

                .contentText {
                    font-size: 24px;
                    color: #000000;
                    line-height: 32px;
                    margin-top: 34px;
                }
            }
        }
    }

    .numberBox {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        padding-top: 100px;

        .numberItem {
            padding: 0 30px;

            .topNum {
                font-size: 24px;
                color: #010000;
                line-height: 32px;
                font-weight: bold;
                padding-bottom: 15px;
                margin-bottom: 10px;
                position: relative;
                text-align: center;

                &::after {
                    content: '';
                    width: 45px;
                    height: 2px;
                    background: #000000;
                    position: absolute;
                    left: 50%;
                    transform: translate(-50%, 0);
                    bottom: 0;
                }
            }

            .numText {
                font-size: 20px;
                color: #010000;
                line-height: 24px;
                text-align: center;
            }
        }
    }
}
</style>
